import { DescribeProperty } from '../../common';

export class VersionsInfoResponse {
  @DescribeProperty({ description: 'Version of @xeokit/xeokit-sdk', type: 'string' })
  '@xeokit/xeokit-sdk': string;

  @DescribeProperty({ description: 'Version of @creooxag/cxconverter', type: 'string' })
  '@creooxag/cxconverter': string;

  @DescribeProperty({ description: 'Version of xeoRVT', type: 'string' })
  'xeoRVT': string;
}
